export default __webpack_public_path__ + "static/media/lost.7f30d13b.svg";